import { IGridElement, ISheetHeaders } from '../../types';

export const mapLinkToApi = (headers: ISheetHeaders, rowData: IGridElement[]) =>
  headers.map((h, index) => {
    const cellValue = rowData[index].value;
    const isSelect = h.options.length > 0;
    if (!isSelect) {
      return {
        id: h.id,
        name: h.label,
        valueText: cellValue,
      };
    }
    return {
      id: h.id,
      name: h.label,
      selectedItemId: cellValue ? Number(cellValue) : null,
    };
  });



// WEBPACK FOOTER //
// ./src/views/LinkCreateBulk/components/services/mapLinkToApi.ts